module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_6000.e2883375.png";